// src/config/auth.js
// Shared authentication/session handling for KGOnline Web + MFSetu mobile apps.

const AUTH_FAILURE_CODES = new Set([
  "AUTH_TOKEN_REQUIRED",
  "INVALID_AUTH_TOKEN",
  "AUTH_TOKEN_EXPIRED",
  "AUTH_SESSION_IDLE_EXPIRED",
  "ACCOUNT_NOT_ACTIVE",
]);

export const getDistributorToken = () =>
  sessionStorage.getItem("distributor_auth_token") || "";

export const getClientToken = () =>
  sessionStorage.getItem("client_auth_token") || "";

export const clearDistributorSession = () => {
  sessionStorage.removeItem("distributor_auth_token");
  ["distributor_auth_token", "arn_number", "arn_holder_name", "is_admin", "isadmin", "admin", "isAdmin"]
    .forEach((key) => localStorage.removeItem(key));
};

export const clearClientSession = () => {
  sessionStorage.removeItem("client_auth_token");
  [
    "client_auth_token", "client_user_id", "client_name", "client_pan",
    "client_arn_no", "client_isgroupadmin", "client_isgroupchild",
    "client_isallowedtoviewwholegroup"
  ].forEach((key) => localStorage.removeItem(key));
};

export const redirectDistributorToLogin = () => {
  clearDistributorSession();
  if (window.location.pathname !== "/login") window.location.replace("/login");
};

export const redirectClientToLogin = () => {
  clearClientSession();
  if (window.location.pathname !== "/client/login") window.location.replace("/client/login");
};

export const isAuthenticationFailure = (response, data) => {
  const code = String(data?.code || "");
  if (!AUTH_FAILURE_CODES.has(code)) return false;
  if (response?.status === 401) return true;
  return response?.status === 403 && code === "ACCOUNT_NOT_ACTIVE";
};

export const handleDistributorAuthFailure = (response, data) => {
  if (!isAuthenticationFailure(response, data)) return false;
  redirectDistributorToLogin();
  return true;
};

export const handleClientAuthFailure = (response, data) => {
  if (!isAuthenticationFailure(response, data)) return false;
  redirectClientToLogin();
  return true;
};
